module.exports = __webpack_public_path__ + "img/green_circle_with_white_cross1.ae2fc55.png";